/* eslint-env browser */

import * as React from 'react'
const PropTypes = require('prop-types')
const classNames = require('classnames')

const EmptyImagesGenerator = require('../../../../../shared/services/empty-images-generator')

class EmptyData extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emptyImageUrl: EmptyImagesGenerator.getEmptyImage({ id: props.emptyableId }),
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      emptyImageUrl: EmptyImagesGenerator.getEmptyImage({ id: nextProps.emptyableId }),
    })
  }

  render() {
    const { emptyImageUrl } = this.state
    const { title, subtitle, cta, isSmall } = this.props
    return (
      <div className="has-text-centered animated fadeIn faster">
        <figure
          className={classNames('image', {
            'is-128x128 is-64x64-mobile': !isSmall,
            'is-64x64 is-32x32-mobile': isSmall,
          })}
          style={{ margin: '0 auto' }}
        >
          <img alt={title || subtitle || ''} src={emptyImageUrl} />
        </figure>
        {title && (
          <p
            className={classNames('title', {
              'is-size-3-desktop is-size-4-tablet is-size-5-mobile': !isSmall,
              'is-size-5-desktop is-size-6-tablet is-size-7-mobile': isSmall,
            })}
          >
            {title}
          </p>
        )}
        {subtitle && (
          <p
            className={classNames('subtitle', {
              'is-size-5-desktop is-size-6-tablet is-size-7-mobile': !isSmall,
              'is-size-6-desktop is-size-7-tablet is-size-8-mobile': isSmall,
            })}
          >
            {subtitle}
          </p>
        )}
        {cta && (
          <a
            href={cta.targetUrl || `mailto:contact@fishfriender.com?subject=${cta.mailSubject}&body=${cta.mailContent}`}
            target="_blank"
            rel="noopener noreferrer"
            className="button is-call-to-action"
          >
            {cta.title}
          </a>
        )}
      </div>
    )
  }
}

EmptyData.propTypes = {
  emptyableId: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  cta: PropTypes.object,
  isSmall: PropTypes.bool,
}

EmptyData.defaultProps = {
  title: null,
  subtitle: null,
  cta: null,
  isSmall: false,
}

module.exports = EmptyData
